module.exports = __webpack_public_path__ + "static/media/haiti-map.52103f0f.png";